import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=e4166d68&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"
import style0 from "./hero.vue?vue&type=style&index=0&id=e4166d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4166d68",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalEducator: require('/usr/src/app/components/modal/educator.vue').default,ModalBasic: require('/usr/src/app/components/modal/basic.vue').default})
